const styleSheet = () => ({
  checkBoxGroup: {
    '& > [role=checkbox]:first-child': {
      margin: '8px 0 17px',
    },
  },
  memberCheckBox: {
    margin: '0 0 17px 25px',
  },
});
export default styleSheet;
